import { createdDate } from './createdDate';
import { name } from './name';
import { username } from './username';
import { authType } from './authType';

export const columns = [name, username, createdDate, authType];
